import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CoalService } from 'app/services/coal.service';
import { select, Store } from '@ngrx/store';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { selectUtilsState } from 'app/store/app.states';
import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'environments/environment';
import { HttpEventType, HttpResponse } from '@angular/common/http';


interface IFiles {
  id: string;
  index: number;
  file: File;
  ext: string;
  isOk: boolean;
  msj: string;
  progress: number;
  tableResult: any[];
  fileResult?: any;
}

@Component({
  selector: 'app-import-invoices',
  templateUrl: './import-invoices.component.html',
  styleUrls: ['./import-invoices.component.scss'],
})
export class ImportInvoicesComponent implements OnInit {

  empresaData: any;
  myFiles: IFiles[] = [];
  btnDisabled: boolean = false;
  urlFile: string = '';
  api: string = '';
  dataField: string = '';

  columnsMsn: string[] = ['line', 'name', 'description'];

  configured: boolean = null;

  constructor(
    public dialog: MatDialog,
    private srvcoal: CoalService,
    private _snackBar: MatSnackBar,
    private store: Store,
  ) {

    this.store.pipe(select(selectUtilsState)).subscribe((infoEmpresa: any) => {
      console.log("🚀 ~ this.store.pipe ~ infoEmpresa:", infoEmpresa)
      if( infoEmpresa?.empresaSeleccionada === undefined ){
        this.configured = false;
      }
      else{
        this.configured = true;
        this.empresaData = infoEmpresa?.empresaSeleccionada || null;
      }
    });

    this.urlFile = environment.serviceUrl.substring(0, environment.serviceUrl.indexOf("api") - 1);
  }

  ngOnInit(): void {


  }


  Excepciones(pila, tipoExcepcion: number) {
    try {
      const dialogRef = this.dialog.open(ExcepcionesComponent, {
        width: '60%',
        data: {
          idTipoExcepcion: tipoExcepcion,
          idUsuario: 1,
          idOperacion: 1,
          idAplicacion: 1,
          moduloExcepcion: 'sel-caja-historial.component',
          mensajeExcepcion: '',
          stack: pila,
        },
      });
      dialogRef.afterClosed().subscribe((result: any) => { });
    } catch (error) {
      // console.error(error);
    }
  }


  /**
 * on file drop handler
 */
  onFileDropped($event) {
    //console.log("🚀 ~ ImportInvoicesComponent ~ onFileDropped ~ event:", event)
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  /**
   * handle file from browsing
   */
  async fileBrowseHandler(ff: any[]): Promise<void> {
    console.log("🚀 fileBrowseHandler ~ ff:", ff)

    this.btnDisabled = true;
    this.myFiles = [];
    let index: number = 0;
    for await (const item of ff) {
      try {

        let type = item.type;
        let name = item.name;
        let ext = String(name.substr(name.lastIndexOf('.'))).toLowerCase();
        let isExtension = ext === '.xml'; // if(type == 'text/xml' || type == 'application/pdf' || type == 'image/png' || type == 'image/jpeg')
        let f1: IFiles = { id: '', index: index, file: item, ext: ext, isOk: isExtension, msj: 'ARCHIVO EN PROCESO...', progress: 0, tableResult: [] };
        if (isExtension) {
          this.myFiles.push(f1);
          //Save File
          await this.sendDataXML(f1);

        } else {
          f1.progress = 0;
          f1.msj = 'FORMATO DE ARCHIVO NO VALIDO!';
          this.myFiles.push(f1);
          //this.buttonDisabled = true;
        }
        index++;

      } catch (error) {
        console.error(error);
      }
    }//Fin For
    //Fin Mensaje 
    this._snackBar.open("PROCESO FINALIZADO!",'OK',{ duration: 5000 });
    this.btnDisabled = false;

  }

  sendDataXML(myFile: IFiles): Promise<boolean> {
    this.store.dispatch(MostrarSpinner());
    return new Promise<boolean>(resolve => {

      //4=Updaload/Facturas/import-xml  // folder: 4 
      this.srvcoal.uploadFile('upload', myFile.file, '4').subscribe({
        next: async (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.myFiles[myFile.index].progress = Math.round((100 * event.loaded) / event.total);//the upload process
          } else if (event instanceof HttpResponse) {
            console.log("🚀 ~ ImportInvoicesComponent ~ this.srvcoal.postServiceFile ~ event FILE RESULT:", event)
            //this.store.dispatch(OcultarSpinner());
            let mydata = (Array.isArray(event?.body) && event?.body?.length > 0) ? event?.body[0] : {};
            //Existe Archivo
            if (mydata?.id) {
              this.myFiles[myFile.index].fileResult = mydata;
              let params = {
                idEmpresa: this.empresaData?.id || null,
                rfc: this.empresaData?.attributes?.rfc || null,
                file: mydata || null
              };
              //Proccess XML....
              const xmlOk = await this.proccessXML(params, myFile.index);
              //console.log("🚀 ~ next: ~ xmlOk:", xmlOk)
              this.store.dispatch(OcultarSpinner());
              resolve(xmlOk);
              //this.myFiles[myFile.index].tableResult
            }
            //this.myFiles[myFile.index].tableResult = this.dataSourceMsn
          }
        },
        error: (err: any) => {
          console.log("🚀 ~ ImportInvoicesComponent ~ this.srvcoal.postServiceFile ~ err:", err)
          this.myFiles[myFile.index].progress = 0;
          this.store.dispatch(OcultarSpinner());
          resolve(false);
        },
        complete: () => {
          //this.store.dispatch(OcultarSpinner());
          //this.myFiles[myFile.index].progress = 100;
          //console.log("🚀 ~ ImportInvoicesComponent ~ this.srvcoal.postServiceFile ~ complete:",)
          // resolve(true);
        }
      });

    });
  }


  proccessXML(model: any, index: number): Promise<boolean> {

    return new Promise<boolean>(resolve => {

      this.srvcoal.postService(`tar-recuperacion/xml`, model).subscribe((result: any) => {

        console.log("🚀 ~ this.srvcoal.postService ~ result: XML", result)
        let msjs = (result?.data?.attributes?.response || []) as Array<any>;
        let ok = Boolean(result?.data?.attributes?.flag || false);
        this.myFiles[index].isOk = ok;
        this.myFiles[index].tableResult = msjs;

        if (ok)
          this.myFiles[index].msj = "EL ARCHIVO XML FUE PROCESADO!";
        else
          this.myFiles[index].msj = "ERROR AL IMPORTAR ARCHIVO XML";

        resolve(ok);
      },
        (err) => {
          this.myFiles[index].isOk = false;
          this.myFiles[index].msj = "OCURRIO UN ERROR AL PROCESAR EL ARCHIVO XML";
          console.log('Error', err);
          resolve(false);
        });

    });

  }

}
